import * as React from 'react';
import classNames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from 'helpers/theme';
import CarouselImage, { Image } from 'components/Misc/CarouselImage';

const useStyles = createUseStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    height: '100vh',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: '70px 0',
  },
  carousel: {
    width: '50vw',
    maxWidth: '668px',
    '@media (max-width: 1000px)': {
      width: '80vw',
    },
  },
  image: {
    height: '68px',
    width: '178px',
    margin: '25px 0 10px 0',
  },
  text: {
    fontSize: '28px',
    fontWeight: '800',
    color: theme.colors.primaryWhite,
    textAlign: 'center',
    maxWidth: '525px',
  },
  demoText: {
    marginTop: '20px',
    fontSize: theme.fontSizes.large,
    fontWeight: '600',
    color: theme.colors.primaryWhite,
    textAlign: 'center',
    maxWidth: '525px',
  },
  emailLink: {
    color: theme.colors.primaryWhite,
    fontWeight: '800',
    textDecoration: 'underline',
  },
}));

type Props = {
  images: Image[];
  className?: string;
};

function RegistrationCarousel({ images, className }: Props) {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classNames(classes.root, className)}>
      <CarouselImage className={classes.carousel} images={images} />
      <img
        className={classes.image}
        src={require('assets/CustomerChampions.svg')}
      />
      <div className={classes.text}>Still not sure? We are here to help</div>
      <div className={classes.demoText}>
        To book a demo, contact{' '}
        <a className={classes.emailLink} href="mailto:admin@ttc-hub.com">
          admin@ttc-hub.com
        </a>
      </div>
    </div>
  );
}

export default RegistrationCarousel;
